import React from "react";
import { Box, Button, Typography } from "@mui/joy";
import { FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";

function ErrorFallback(props: FallbackProps) {
  const [t] = useTranslation();
  console.log(props);

  return (
    <Box
      width={"100vw"}
      height={"100vh"}
      display="flex"
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      sx={{ backgroundColor: "#f6f8fc" }}
      gap={4}
    >
      {/* Logo */}
      <Box height={80}>
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          width="250px"
          height="100%"
          viewBox="0 0 280 50"
          colorInterpolationFilters="sRGB"
          style={{ margin: "auto" }}
        >
          <g fill="#333" className="icon-text-wrapper icon-svg-group iconsvg">
            <g className="iconsvg-imagesvg" transform="translate(0,0)">
              <g>
                <rect
                  fill="#333"
                  fillOpacity="0"
                  strokeWidth="2"
                  x="0"
                  y="0"
                  width="60"
                  height="60.640975106879715"
                  className="image-rect"
                ></rect>{" "}
                <svg
                  x="0"
                  y="0"
                  width="60"
                  height="60.640975106879715"
                  filter="colorsb8129018875"
                  className="image-svg-svg primary"
                  style={{ overflow: "visible" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0.029999732971191406 -0.06999969482421875 49.59000015258789 50.119998931884766"
                  >
                    <path
                      d="M11.82 50.05c-3.26 0-6.53-.06-9.79 0-1.55 0-2-.6-2-2.07q.08-9.69 0-19.39c0-1.52.56-2.06 2.07-2.05 6.52.06 13.05.05 19.57 0 1.54 0 2.06.64 2.05 2.1v19.39c0 1.52-.6 2-2.09 2-3.29-.03-6.55.02-9.81.02z"
                      fill="#BBDEFB"
                    ></path>
                    <path
                      d="M26.23 11.93v-10c0-1.43.56-2 2-2q9.69.06 19.39 0c1.4 0 2 .48 2 1.93q-.06 9.78 0 19.57c0 1.33-.52 1.87-1.87 1.86H28c-1.31 0-1.84-.38-1.79-1.83.13-3.2 0-6.4 0-9.6z"
                      fill="#1976D2"
                    ></path>
                    <path
                      d="M23.52 14.56v7.38c0 1.26-.45 1.82-1.7 1.81H6.68c-1.25 0-1.81-.55-1.81-1.78V7.2c0-1.35.57-2 2-2h14.77c1.25 0 1.78.53 1.76 1.78v7.57z"
                      fill="#2196F3"
                    ></path>
                    <path
                      d="M37.43 31.68v4.24A1.29 1.29 0 0 1 36 37.4h-8.35c-1 0-1.42-.54-1.42-1.51v-8.5a1.3 1.3 0 0 1 1.47-1.49H36c1 0 1.43.55 1.42 1.52 0 1.42.01 2.84.01 4.26z"
                      fill="#64B5F6"
                    ></path>
                  </svg>
                </svg>
              </g>
            </g>
            <g transform="translate(74.25,16.640975952148438)">
              <g className="tp-name iconsvg-namesvg">
                <g transform="scale(1)">
                  <g>
                    <path
                      d="M19.07-15.91Q19.07-14.06 18.2-12.44 17.32-10.82 15.46-9.83 13.6-8.84 10.76-8.84L10.76-8.84 6.9-8.84 6.9 0 2.28 0 2.28-23.03 10.76-23.03Q13.43-23.03 15.31-22.11 17.19-21.19 18.13-19.57 19.07-17.95 19.07-15.91L19.07-15.91ZM10.56-12.57Q12.47-12.57 13.4-13.45 14.32-14.32 14.32-15.91L14.32-15.91Q14.32-19.27 10.56-19.27L10.56-19.27 6.9-19.27 6.9-12.57 10.56-12.57ZM22.34-24.42L26.96-24.42 26.96 0 22.34 0 22.34-24.42ZM30.33-9.21Q30.33-11.98 31.43-14.12 32.54-16.27 34.44-17.42 36.33-18.58 38.68-18.58L38.68-18.58Q40.72-18.58 42.26-17.75 43.79-16.93 44.72-15.68L44.72-15.68 44.72-18.28 49.37-18.28 49.37 0 44.72 0 44.72-2.67Q43.82-1.39 42.26-0.54 40.69 0.3 38.64 0.3L38.64 0.3Q36.33 0.3 34.44-0.89 32.54-2.08 31.43-4.24 30.33-6.4 30.33-9.21L30.33-9.21ZM44.72-9.14Q44.72-10.82 44.05-12.03 43.39-13.23 42.27-13.88 41.15-14.52 39.86-14.52L39.86-14.52Q38.58-14.52 37.49-13.89 36.4-13.27 35.72-12.06 35.05-10.86 35.05-9.21L35.05-9.21Q35.05-7.56 35.72-6.32 36.4-5.08 37.5-4.42 38.61-3.76 39.86-3.76L39.86-3.76Q41.15-3.76 42.27-4.41 43.39-5.05 44.05-6.25 44.72-7.46 44.72-9.14L44.72-9.14ZM64.02-18.55Q67.29-18.55 69.3-16.48 71.31-14.42 71.31-10.72L71.31-10.72 71.31 0 66.69 0 66.69-10.1Q66.69-12.28 65.6-13.45 64.52-14.62 62.63-14.62L62.63-14.62Q60.72-14.62 59.61-13.45 58.51-12.28 58.51-10.1L58.51-10.1 58.51 0 53.89 0 53.89-18.28 58.51-18.28 58.51-16Q59.43-17.19 60.87-17.87 62.3-18.55 64.02-18.55L64.02-18.55ZM85.83-18.55Q89.1-18.55 91.11-16.48 93.13-14.42 93.13-10.72L93.13-10.72 93.13 0 88.51 0 88.51-10.1Q88.51-12.28 87.42-13.45 86.33-14.62 84.45-14.62L84.45-14.62Q82.53-14.62 81.43-13.45 80.32-12.28 80.32-10.1L80.32-10.1 80.32 0 75.7 0 75.7-18.28 80.32-18.28 80.32-16Q81.25-17.19 82.68-17.87 84.12-18.55 85.83-18.55L85.83-18.55ZM114.51-9.54Q114.51-8.55 114.38-7.76L114.38-7.76 101.01-7.76Q101.18-5.78 102.4-4.65 103.62-3.53 105.4-3.53L105.4-3.53Q107.98-3.53 109.07-5.74L109.07-5.74 114.05-5.74Q113.26-3.1 111.01-1.4 108.77 0.3 105.5 0.3L105.5 0.3Q102.86 0.3 100.77-0.87 98.67-2.05 97.5-4.19 96.33-6.34 96.33-9.14L96.33-9.14Q96.33-11.98 97.48-14.12 98.64-16.27 100.72-17.42 102.8-18.58 105.5-18.58L105.5-18.58Q108.11-18.58 110.17-17.46 112.23-16.34 113.37-14.27 114.51-12.21 114.51-9.54L114.51-9.54ZM101.05-10.86L109.73-10.86Q109.69-12.64 108.44-13.71 107.18-14.78 105.37-14.78L105.37-14.78Q103.65-14.78 102.48-13.74 101.31-12.71 101.05-10.86L101.05-10.86ZM122.5-15.44Q123.39-16.9 124.82-17.72 126.26-18.55 128.11-18.55L128.11-18.55 128.11-13.7 126.89-13.7Q124.71-13.7 123.6-12.67 122.5-11.65 122.5-9.11L122.5-9.11 122.5 0 117.88 0 117.88-18.28 122.5-18.28 122.5-15.44ZM149.75 0.23Q146.52 0.23 143.81-1.29 141.11-2.81 139.52-5.49 137.94-8.18 137.94-11.58L137.94-11.58Q137.94-14.95 139.52-17.64 141.11-20.33 143.81-21.85 146.52-23.36 149.75-23.36L149.75-23.36Q153.02-23.36 155.71-21.85 158.4-20.33 159.97-17.64 161.54-14.95 161.54-11.58L161.54-11.58Q161.54-8.18 159.97-5.49 158.4-2.81 155.69-1.29 152.99 0.23 149.75 0.23L149.75 0.23ZM149.75-3.89Q151.83-3.89 153.42-4.83 155-5.78 155.89-7.52 156.78-9.27 156.78-11.58L156.78-11.58Q156.78-13.89 155.89-15.63 155-17.36 153.42-18.28 151.83-19.21 149.75-19.21L149.75-19.21Q147.68-19.21 146.07-18.28 144.47-17.36 143.58-15.63 142.69-13.89 142.69-11.58L142.69-11.58Q142.69-9.27 143.58-7.52 144.47-5.78 146.07-4.83 147.68-3.89 149.75-3.89L149.75-3.89ZM175.1-18.55Q178.37-18.55 180.38-16.48 182.39-14.42 182.39-10.72L182.39-10.72 182.39 0 177.77 0 177.77-10.1Q177.77-12.28 176.68-13.45 175.59-14.62 173.71-14.62L173.71-14.62Q171.8-14.62 170.69-13.45 169.59-12.28 169.59-10.1L169.59-10.1 169.59 0 164.97 0 164.97-18.28 169.59-18.28 169.59-16Q170.51-17.19 171.95-17.87 173.38-18.55 175.1-18.55L175.1-18.55ZM203.78-9.54Q203.78-8.55 203.64-7.76L203.64-7.76 190.28-7.76Q190.44-5.78 191.66-4.65 192.89-3.53 194.67-3.53L194.67-3.53Q197.24-3.53 198.33-5.74L198.33-5.74 203.31-5.74Q202.52-3.1 200.28-1.4 198.03 0.3 194.77 0.3L194.77 0.3Q192.13 0.3 190.03-0.87 187.94-2.05 186.76-4.19 185.59-6.34 185.59-9.14L185.59-9.14Q185.59-11.98 186.75-14.12 187.9-16.27 189.98-17.42 192.06-18.58 194.77-18.58L194.77-18.58Q197.37-18.58 199.44-17.46 201.5-16.34 202.64-14.27 203.78-12.21 203.78-9.54L203.78-9.54ZM190.31-10.86L198.99-10.86Q198.96-12.64 197.7-13.71 196.45-14.78 194.63-14.78L194.63-14.78Q192.92-14.78 191.75-13.74 190.58-12.71 190.31-10.86L190.31-10.86Z"
                      transform="translate(-2.2799999713897705, 24.420000076293945)"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </Box>
      <Box
        flex={"0.3 1 150px"}
        bgcolor={"#fff"}
        borderRadius={8}
        p={2}
        textAlign={"center"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        gap={2}
      >
        <Box>
          <Typography level="h4" fontWeight={600}>
            Ooops!
          </Typography>
          <Typography level="h5" fontWeight={600}>
            {t("Something went wrong")}.
          </Typography>
        </Box>

        <Typography level="body1" color="danger">
          {props.error.message}
        </Typography>
        <Typography
          level="body3"
          color="danger"
          sx={{
            textAlign: "start",
            whiteSpace: "pre-wrap",
          }}
        >
          <Typography fontWeight={600}>{"Stack Trace: \n"}</Typography>
          {props.error.stack}
        </Typography>
        <Button
          fullWidth
          color="primary"
          variant="solid"
          onClick={props.resetErrorBoundary}
        >
          {t("Reload")}
        </Button>
      </Box>
    </Box>
  );
}

export default ErrorFallback;
